import { FolderCreationResponse, FolderTreeResponse, PatchFolderItemType, SelectedFolderItemType } from 'types/folders'

import { RequestService } from 'services/request.service'

export class FolderService extends RequestService {
  public details = (id?: number | string, queryString: string = '') => {
    let folderId = id
    let params = queryString

    return super.get(`/api/decks/folders/${folderId}/?${params}`)
  }

  public deleteItems = (items: SelectedFolderItemType[]) => {
    return super.post('/api/decks/folders/deleteItems/', { items })
  }

  public updateItems = (items: PatchFolderItemType[]) => {
    return super.patch('/api/massUpdate/', { items })
  }

  public create = (name: string, isPrivate: boolean, parentFolderId: string | number) => {
    return super.post<FolderCreationResponse>('/api/decks/folders/', {
      name,
      private: isPrivate,
      parentFolder: parentFolderId,
    })
  }

  public folderTree = () => {
    return super.get<FolderTreeResponse>(`/api/decks/folderTree/`)
  }
}

const folderService = new FolderService()

export default folderService
